import { render } from "./farmPolygon.vue?vue&type=template&id=2435b8da&scoped=true"
import script from "./farmPolygon.vue?vue&type=script&lang=js"
export * from "./farmPolygon.vue?vue&type=script&lang=js"

import "./farmPolygon.vue?vue&type=style&index=0&id=2435b8da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2435b8da"]])

export default __exports__